const scripts = new Map()

function loadScript(src) {
  if (!scripts.has(src)) {
    scripts.set(src, new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = src
      script.onload = resolve
      script.onerror = () => {
        scripts.delete(src)
        script.remove()
        reject(new Error("Nie udało się załadować " + src))
      }
      document.body.appendChild(script)
    }))
  }
  return scripts.get(src)
}

export const onRouteUpdate = async () => {
  const widget = document.getElementById("cs_terminy1")
  if (!widget) return
  try {
    if (!window.jQuery) await loadScript("/js/jquery.js")
    window.$ = window.jQuery
    if (!window.jQuery.fn.colorbox) {
      await loadScript("/js/jquery.colorbox.js?ver=1.0.0")
    }
    if (document.getElementById("cs_terminy1") !== widget) return
    const openReservation = (href) => {
      window.jQuery.colorbox({
        iframe: true,
        open: true,
        href,
        width: window.sykonCboxWidth || 1200,
        maxWidth: "95%",
        height: "90%",
        fastIframe: false,
        overlayClose: false,
        className: "sykon-cbox",
        onComplete: () => {
          if (typeof window.sc2_SykonAnalytics === "function") window.sc2_SykonAnalytics()
        },
      })
      return false
    }
    if (typeof window.terminyVUE === "function") window.terminyVUE()
    else {
      await loadScript("/js/docready.js?ver=1.0.0")
      await new Promise((resolve, reject) => {
        const started = Date.now()
        const check = () => {
          if (typeof window.terminyVUE === "function") resolve()
          else if (Date.now() - started > 15000) reject(new Error("NSykon nie uruchomił modułu terminów"))
          else setTimeout(check, 100)
        }
        check()
      })
    }
    window.popitup = openReservation
  } catch (error) {
    console.error("Błąd ładowania zapisów NSykon", error)
  }
}